const faq = [
  {
    question: "What is Xenorize, and how does it work?",
    answer:
      "Xenorize is a crypto trading platform that offers automated trade bots designed to help users maximize trading opportunities. The bots operate 24/7, allowing users to trade without needing to monitor the market constantly.",
  },
  {
    question: "How do I get started with Xenorize’s trade bots?",
    answer:
      "To get started, simply sign up, top up your wallet with USDT, and activate your preferred trade bot. You can also use the ‘TRADE’ feature to convert other cryptocurrencies into USDT.",
  },
  {
    question: "What types of trade bots are available on Xenorize?",
    answer:
      "Our flagship bot, USAGI, uses a GRID trading strategy to buy low and sell high during market fluctuations. Additional strategies, such as DCA (Dollar Cost Averaging), will be introduced in future updates.",
  },
  {
    question:
      "Is there a minimum amount required to start using a trade bot?",
    answer:
      "Yes, each bot has a recommended minimum balance in USDT to ensure optimal performance. You can find the details on each bot’s setup page.",
  },
  {
    question: "How secure is my crypto when using Xenorize?",
    answer:
      "Xenorize is a noncustodial platform, meaning your funds remain securely in your exchange account (e.g., Binance). We do not hold or manage your funds directly.",
  },
  {
    question: "Can I withdraw my funds anytime?",
    answer:
      "Yes, since your funds remain in your connected exchange account, you can withdraw them at any time directly from the exchange.",
  },
  {
    question: "What is the ‘TRADE’ feature, and how does it work?",
    answer:
      "The TRADE feature allows you to convert other cryptocurrencies into USDT, which is required to run the trade bots. You can access this feature on your wallet page.",
  },
  {
    question: "Are profits guaranteed when using trade bots on Xenorize?",
    answer:
      "No, crypto trading involves risk, and profits are not guaranteed. The performance of trade bots may vary due to market conditions. We advise users to trade responsibly and do their own research.",
  },
];
export default faq